module.exports = __webpack_public_path__ + "static/media/ue5_1.3a6f8d1c.jpg";